import { createApi } from "../../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";
import { useAppStore } from "../../../../../appStore";

export const handleDeleteSite = async (
  id: number,
  navigate: any,
  setBackdropLoadingScreenOn: any
) => {
  const AxiosUI = createApi(``);
  setBackdropLoadingScreenOn(true);
  const retryFunction = () => {
    handleDeleteSite(id, navigate, setBackdropLoadingScreenOn);
  };

  // Get site info to determine if it's an autopatrol site
  let isAutopatrolSite = false;
  try {
    const siteInfoStr = localStorage.getItem("siteInfo");
    if (siteInfoStr) {
      const siteInfo = JSON.parse(siteInfoStr);
      isAutopatrolSite = siteInfo?.integration_type_name === "autopatrol";
    }
  } catch (e) {
    // If we can't parse siteInfo, default to false
  }

  await AxiosUI.delete(`customer/${id}/`).then(
    async () => {
      // Set alert flags before attempting to refresh group trees
      localStorage.setItem("siteDeletedAlert", "true");
      localStorage.setItem("siteJustDeleted", "true");

      // Try to refresh group trees, but navigate regardless of success/failure
      await AxiosUI.get("group/tree/?group_type=connector&page_size=1000").then(
        (response: AxiosResponse) => {
          useAppStore.getState().setGroupTrees(response.data.results);
        },
        (reason: AxiosError) => {
          // Log error but don't prevent navigation
          console.error("Failed to refresh group trees after delete:", reason);
        }
      );

      // Always navigate after successful delete
      setBackdropLoadingScreenOn(false);
      const targetRoute = isAutopatrolSite ? "/sites_patrol" : "/sites";
      navigate(targetRoute);
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setBackdropLoadingScreenOn(false);
        alert(`Error deleting site, please try again.`);
      });
    }
  );
};
